import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab, Chip } from '@mui/material';
import { LocalShipping, Category, History, Refresh } from '@mui/icons-material';
import { WarehouseAPI } from '../services/api';
import PageHeader from '../components/common/PageHeader';
import CardingTab from './CardingTab';
import CardingPackagingUsageTab from './CardingPackagingUsageTab';
import CardingMoveLogsTab from './CardingMoveLogsTab';
import CardingPackagingHistoryTab from './CardingPackagingHistoryTab';

const TAB_KEYS = ['carding', 'packaging', 'logs', 'history'] as const;

const CardingPage: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const tab = Math.max(0, TAB_KEYS.indexOf((tabParam as typeof TAB_KEYS[number]) || 'carding'));
    const setTab = (v: number) => {
        setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.set('tab', TAB_KEYS[v]);
            return next;
        });
    };
    const [lastSyncTime, setLastSyncTime] = useState<string | null>(null);

    useEffect(() => {
        WarehouseAPI.getLastCardingSyncTime().then(setLastSyncTime).catch(console.error);
    }, []);

    return (
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, pt: 2, pb: 3 }}>
            <PageHeader
                icon={<LocalShipping sx={{ color: '#DC5829', fontSize: '1.9rem' }} />}
                title="Carding"
                subtitle="Move SKUs from NONCARDED shelves to a carded shelf, with packaging deduction from Plytix"
                actions={lastSyncTime ? (
                    <Chip
                        icon={<Refresh sx={{ fontSize: 16 }} />}
                        label={`Last Sync: ${new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short' }).format(new Date(lastSyncTime))} IST`}
                        size="small"
                        sx={{ fontWeight: 600, bgcolor: 'rgba(220, 88, 41, 0.1)', color: '#B8451E', mt: 0.5 }}
                    />
                ) : undefined}
            />

            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 2 }}>
                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                >
                    <Tab icon={<LocalShipping sx={{ fontSize: 18 }} />} label="Carding" iconPosition="start" />
                    <Tab icon={<Category sx={{ fontSize: 18 }} />} label="Packaging usage" iconPosition="start" />
                    <Tab icon={<History sx={{ fontSize: 18 }} />} label="Move logs" iconPosition="start" />
                    <Tab icon={<History sx={{ fontSize: 18 }} />} label="History" iconPosition="start" />
                </Tabs>
            </Box>

            {tab === 0 ? <CardingTab /> : tab === 1 ? <CardingPackagingUsageTab /> : tab === 2 ? <CardingMoveLogsTab /> : <CardingPackagingHistoryTab />}
        </Box>
    );
};

export default CardingPage;
